// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Letter types'" tab="true"></sub-header>
  <form name="\$ctrl.form">
    <table class="table table--last-column-to-right">
      <thead>
      <tr>
        <th class="no-column-header">No</th>
        <th>Name</th>
        <th>Description</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in \$ctrl.types" ng-form name="\$ctrl['form_' + \$index]">
          <td>{{\$index + 1}}.</td>
          <td ng-if="!item.inputMode">{{item.name}}</td>
          <td ng-if="!item.inputMode">{{item.description}}</td>
          <td ng-if="item.inputMode">
            <input
              type="text"
              required
              ng-model="item.name"
              minlength="1"
              maxlength="64"
            />
          </td>
          <td ng-if="item.inputMode">
            <input
              type="text"
              ng-model="item.description"
              minlength="1"
              maxlength="512"
            />
          </td>
          <td class="table__actions">
            <button ng-if="!item.inputMode"
                    class="btn btn-danger pull-right"
                    type="button"
                    command-access="DeleteLetterType"
                    ng-click="\$ctrl.remove(\$index)">Remove</button>
            <button ng-if="!item.inputMode"
                    class="btn btn-warning pull-right"
                    type="button"
                    command-access="UpdateLetterType"
                    ng-click="\$ctrl.edit(\$index)">Edit</button>
            <button ng-if="item.inputMode"
                    class="btn btn-danger pull-right"
                    type="button"
                    ng-click="\$ctrl.cancel(\$index)">Cancel</button>
            <button ng-if="item.inputMode"
                    class="btn btn-success pull-right save-button"
                    type="button"
                    command-access="CreateLetterType, UpdateLetterType"
                    ng-click="\$ctrl.save(\$index)">Save</button>
          </td>
        </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="4" class="type-list__add-new-column">
          <button class="btn btn-success" type="button" ng-click="\$ctrl.add()">
            Add
          </button>
        </td>
      </tr>
      </tfoot>
    </table>
  </form>

  <div class="buttons">
    <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Back</button>
  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/letter-type/letter-type-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;